import script from "./FeesSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./FeesSetup.vue?vue&type=script&setup=true&lang=js"

import "./FeesSetup.vue?vue&type=style&index=0&id=08726562&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08726562"]])

export default __exports__